import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate, NavLink } from 'react-router-dom';





const pageOrder = [
{
  slug: 'peter-frankopan',
  title: 'Looking back to look forward', 
  author: 'Peter Frankopan',
  description: 'Peter Frankopan says that the latest technologies are shedding new light on the past',
  image: 'frankopan/haaland.jpg'
},
{
  slug: 'miranda-malins',
  title: 'Heads and tales', 
  author: 'Miranda Malins',
  description: 'Miranda Malins on what a republican ‘coronation’ some 365 years ago can tell us about today’s monarchy',
  image: 'malins/cromwell.jpg'
},
{
  slug: 'melissa-harrison',
  title: 'How does your garden grow?', 
  author: 'Melissa Harrison',
  description: 'Melissa Harrison on how Britain’s 30 million gardens might help address the linked issues of climate change and biodiversity loss',
  image: 'harrison/garden.jpg'
},
{
  slug: 'jenny-natusch',
  title: 'Teen spirit', 
  author: 'Jenny Natusch',
  description: 'Jenny Natusch is a social entrepreneur on a mission to turn the tide in how we support our young people',
  image: 'natusch/ecosystem.png'
},
{
  slug: 'vaseem-khan',
  title: 'The never-ending Golden Age of Golden Age crime fiction', 
  author: 'Vaseem Khan',
  description: 'Vaseem Khan on the enduring legacy of the whodunnit and how the very worst can bring out the very best in us',
  image: 'khan/key.jpg'
},
{
  slug: 'james-holland',
  title: 'Method, motivation and morale', 
  author: 'James Holland',
  description: 'James Holland says business could learn a thing or three from the RAF’s wartime effort.',
  image: 'holland/room.jpg'
},
{
  slug: 'michael-taylor',
  title: 'Digging up the past', 
  author: 'Michael Taylor',
  description: 'Michael Taylor explains how scientists used dinosaurs to explain the mysteries of evolution',
  image: 'taylor/big-skull.jpg'
},
{
  slug: 'jonathan-wilson',
  title: 'A prophecy fulfilled', 
  author: 'Jonathan Wilson',
  description: 'Jonathan Wilson explains how in a little over a century the biggest celebrity in Argentina changed from being an imported bull to an exported footballer',
  image: 'wilson/maradona.jpg'
},
{
  slug: 'adam-rutherford',
  title: 'Running in the family', 
  author: 'Adam Rutherford',
  description: 'Adam Rutherford takes us back to some very inbred royals, who just didn’t know their maths, but he’s the bringer of good news for literally all of us',
  image: 'rutherford/tree.jpg'
},
{
  slug: 'alex-massie',
  title: 'Keeping your spirits up', 
  author: 'Alex Massie',
  description: 'Alex Massie on how three women on a Scottish island resorted to gin, though not in the way you might think',
  image: 'massie/lussa-team.jpg'
}

];












const Article = () => {

  const { page } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState('');


  useEffect(() => {
    const fetchContent = async () => {
      console.log('Fetching content...');
      const pageName = page || 'home'; // Default to 'home' if no page param

      const pageNameWithoutHyphens = pageName.replace(/-/g, '');

      try {
        const response = await fetch(`content${pageNameWithoutHyphens}.html`);
        const htmlContent = await response.text();
        setContent(htmlContent);
      } catch (error) {
        console.error('Error fetching content:', error);
      } finally {
        setTimeout(() => {
          navigate(`/${pageName}`);
        }, 300); // Wait for the fade-out transition to complete
      }
    };
    fetchContent();
  }, [page, navigate]);

  
  const getCurrentPage = () => {
    const currentIndex = pageOrder.findIndex((p) => p.slug === (page || 'home'));
    return pageOrder[currentIndex];
  }


  const getNextPage = () => {
    const currentIndex = pageOrder.findIndex((p) => p.slug === (page || 'home'));
    const nextIndex = (currentIndex + 1) % pageOrder.length;
    return pageOrder[nextIndex];
  };

  const getPreviousPage = () => {
    const currentIndex = pageOrder.findIndex((p) => p.slug === (page || 'home'));
    const previousIndex = (currentIndex - 1 + pageOrder.length) % pageOrder.length;
    return pageOrder[previousIndex];
  };

  const isFirstPage = pageOrder.findIndex((p) => p.slug === (page || 'home')) === 0;
  const isLastPage = pageOrder.findIndex((p) => p.slug === (page || 'home')) === pageOrder.length - 1;

  const pageStyle = page?.split('-')[1] || '';

  // Use a unique key for the audio element to force a reload when the key changes
  const audioKey = page || 'default';

  // Get image path base
  // Accessing the current path
  const currentPath = window.location.pathname;
  console.log('Current Path:', currentPath);

  // Remove the last segment from the path
  const pathSegments = currentPath.split('/');
  const updatedPath = pathSegments.slice(0, -1).join('/');
  console.log('Updated Path:', updatedPath);

  // Now, you can use the updated path as needed
  // For example, to reference the "basename/public/img" folder
  const imgFolderPath = `${updatedPath}/img/`;
  console.log('Image Folder Path:', imgFolderPath);


  return (
    <div className={`wrap ${pageStyle || 'home'}`}>

      <Helmet>
        { /* Standard metadata tags */ }
        <title>{getCurrentPage().title} – Rathbones Review 2023</title>
        <meta name='description' content={getCurrentPage().description} />
        { /* End standard metadata tags */ }
        { /* Facebook tags */ }
        <meta property="og:type" content='website' />
        <meta property="og:title" content={getCurrentPage().title} />
        <meta property="og:description" content={getCurrentPage().description} />
        <meta property="og:image" content={imgFolderPath + getCurrentPage().image} />
        { /* End Facebook tags */ }
        { /* Twitter tags */ }
        <meta name="twitter:card" content='summary' />
        <meta name="twitter:title" content={getCurrentPage().title} />
        <meta name="twitter:description" content={getCurrentPage().description} />
        <meta name="twitter:image" content={imgFolderPath + getCurrentPage().image} />
        { /* End Twitter tags */ }
      </Helmet>
      
      <div className="flourish flourish-r"></div>
      <div className="flourish flourish-l"></div>

      <div className="article container">

        <div className="columns is-centered">
          <div className="column is-4 audio">
            <p>Listen to the author reading the article</p>
            <audio key={audioKey}  controls="controls">
              <source src={`audio/${page}.mp3`} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
          </div>
        </div>

        <div className="section" dangerouslySetInnerHTML={{ __html: content }} />

      </div>

      


      <footer className="footer">
        <div className="container section">
          
          <nav className="article-links">


            {!isFirstPage && getPreviousPage() && (
              <div className="article-link">
                <i>←</i>
                <div>
                  <small>Previous Article</small>
                  <NavLink to={`/${getPreviousPage().slug}`}>
                    <strong>{getPreviousPage().title}</strong>
                      {getPreviousPage().author}
                  </NavLink>
                </div>
              </div>
            )}
            
            
            {!isLastPage && getNextPage() && (
              <div className="article-link">
                <div>
                  <small>Next Article</small>
                    <NavLink to={`/${getNextPage().slug}`}>
                      <strong>{getNextPage().title}</strong>
                      {getNextPage().author}
                    </NavLink>
                </div>
                <i>→</i>
              </div>
            )}
            
              
          </nav>

        </div>
      </footer>

    </div>


  );
}




export default Article;